import { saveAs } from 'file-saver'
import moment from 'moment'
import PropTypes from 'prop-types'

import formatValueCsv from '../exportUtils'
import processRows from '../processRows'

const processSummaryRows = (sumData) => {
  const rows = []

  if (!sumData || !Array.isArray(sumData) || sumData.length === 0) {
    return rows
  }

  sumData.forEach((summary) => {
    rows.push([], [])

    if (summary.title) {
      rows.push([summary.title])
    }

    if (summary.columns) {
      const summaryHeader = summary.columns.map((col) => col.title)
      rows.push(summaryHeader)
    }

    if (summary.dataSource && summary.columns) {
      summary.dataSource.forEach((record) => {
        const row = summary.columns.map((col) => formatValueCsv(record[col.dataIndex], col, record))
        rows.push(row)
      })
    }
  })

  return rows
}

const generateCSVContent = (rows) => rows.map((row) => row.map((tuple) => `"${tuple}"`).join(';')).join('\n')

const exportToCSV = ({ columns, dataSource, reportName, exportDetails = false, sumData = [] }) => {
  const detailColumnDef = columns.find((col) => col.columns)

  const mainColumns = columns.filter((col) => (!col.columns || col.columns.length === 0) && col.exportable !== false)

  const detailColumns = detailColumnDef ? detailColumnDef.columns.filter((col) => col.exportable !== false) : []

  const activeColumns = exportDetails ? [...mainColumns, ...detailColumns] : mainColumns

  const header = activeColumns.map((column) => column.title)
  const body = processRows({
    dataSource,
    mainColumns,
    detailColumns,
    activeColumns,
    exportDetails
  })
  const summaryRows = processSummaryRows(sumData)

  const finalRows = [header, ...body, ...summaryRows]
  const csvContent = generateCSVContent(finalRows)
  const reportTimeStamp = moment().format('DD_MM_YYYY_HH_mm_ss')

  const blob = new Blob([csvContent], { type: 'text/csv' })
  saveAs(blob, `relatorio_${reportName}_${reportTimeStamp}.csv`)
}

exportToCSV.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      dataIndex: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired
    })
  ).isRequired,
  dataSource: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])))
    .isRequired,
  reportName: PropTypes.string.isRequired,
  exportDetails: PropTypes.bool,
  sumData: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      columns: PropTypes.arrayOf(
        PropTypes.shape({
          dataIndex: PropTypes.string.isRequired,
          title: PropTypes.string.isRequired
        })
      ).isRequired,
      dataSource: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])))
        .isRequired
    })
  )
}

exportToCSV.defaultProps = {
  exportDetails: false,
  sumData: []
}

export default exportToCSV
